// extracted by css-extract-rspack-plugin
export default {"overlay":"HeaderAgentTasks-module__overlay__hDlmq"};